module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDggMTIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTMuNTM4IDYuMDA0bDMuNzQ1LTMuNzQ2YS45NDguOTQ4IDAgMCAwIC4yODUtLjY5Ny45NDguOTQ4IDAgMCAwLS4yODUtLjY5OEw2LjcwNS4yODVBLjk0OS45NDkgMCAwIDAgNi4wMDggMGEuOTUuOTUgMCAwIDAtLjY5OC4yODVMLjI4NSA1LjMwMkEuOTQ5Ljk0OSAwIDAgMCAwIDZjMCAuMjc1LjA5NS41MDcuMjg1LjY5N2w1LjAyNSA1LjAxOGEuOTUuOTUgMCAwIDAgLjY5OC4yODUuOTQ4Ljk0OCAwIDAgMCAuNjk3LS4yODVsLjU3OC0uNTc4YS45NDMuOTQzIDAgMCAwIC4yODUtLjY5NC45Ny45NyAwIDAgMC0uMjg1LS43MDFMMy41MzggNi4wMDR6IiBmaWxsPSIjZmZmIi8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ../src/images/slideshow-left.svg
// module id = 787
// module chunks = 0